import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagsService } from '../feature-flag/feature-flag.service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagGuard implements CanActivate {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private featureFlags: FeatureFlagsService,
    private router: Router,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    if (!this.isBrowser) {
      return true;
    }

    // read props from route
    const featureFlag = route.data['featureFlag'];
    const redirectUrl = route.data['redirectUrl'] ?? '/dashboard'; // default fallback

    if (!featureFlag) {
      console.warn('FeatureFlagGuard: No featureFlag provided');
      return true;
    }

    const isEnabled = this.featureFlags.isEnabled(featureFlag);

    if (!isEnabled) {
      this.router.navigateByUrl(redirectUrl);
      return false;
    }

    return true;
  }
}
